import { downloadHandoutExport } from '../utils/handoutExportDownload'
import { fetchExportQuota, ExportQuotaError } from '../utils/teacherExportBilling'
import HandoutExportPayDialog from '../components/HandoutExportPayDialog.vue'

export default {
  components: { HandoutExportPayDialog },
  data() {
    return {
      exportQuota: null,
      exportPayVisible: false,
      pendingExportAction: null
    }
  },
  computed: {
    exportQuotaLabel() {
      if (!this.isTeacherMode || !this.exportQuota) return ''
      const remaining = this.exportQuota.remaining != null ? this.exportQuota.remaining : 0
      return `导出剩余 ${remaining} 次`
    }
  },
  created() {
    if (this.isTeacherMode) {
      this.loadExportQuota()
    }
  },
  methods: {
    async loadExportQuota() {
      if (!this.isTeacherMode) return
      try {
        this.exportQuota = await fetchExportQuota()
      } catch (e) {
        this.exportQuota = null
      }
    },
    openExportPayDialog(retryAction) {
      this.pendingExportAction = typeof retryAction === 'function' ? retryAction : null
      this.exportPayVisible = true
    },
    async onExportPaid() {
      await this.loadExportQuota()
      if (this.pendingExportAction) {
        const action = this.pendingExportAction
        this.pendingExportAction = null
        await action()
      }
    },
    buildHandoutExportOptions(extra = {}) {
      return {
        apiBase: this.apiPrefix,
        onQuotaExceeded: () => this.openExportPayDialog(),
        ...extra
      }
    },
    async runHandoutExportDownload(handoutId, options) {
      try {
        await downloadHandoutExport(handoutId, this.buildHandoutExportOptions(options))
        if (this.isTeacherMode) {
          await this.loadExportQuota()
        }
      } catch (e) {
        if (e instanceof ExportQuotaError) {
          return
        }
        throw e
      }
    }
  }
}
